<template>
  <div style="width:100%; height: 100px">
    <custom-automation-node
      :data="data"
      icon="pi-bolt"
      nodeType="trigger"
      title="לקוח נכנס לאתר"
      :showMenuIcon="false"
      @remove="remove"
    />
  </div>

</template>

<script lang="ts" setup>
import { PropType } from 'vue';

const props = defineProps({
  data: {
    type: Object as PropType<Record<string, any>>,
    required: false
  }
});
const emit = defineEmits(['remove']);
const remove = () => {
  emit('remove');
};
</script>

<style scoped>

</style>
